import { merge, Observable, of } from "rxjs";
import { filter, tap } from "rxjs/operators";
import { ExtendedMediaStream } from "../extended-media-stream";

export function mapStreamToVideo(
  stream: ExtendedMediaStream,
  video: HTMLVideoElement
) {
  return new Observable<void>((subscriber) => {
    // Safari's `muted` logic has weird behavior and video object can be unmuted in some cases.
    // In order to fix this issue, create temporary MediaStream object for the video tracks only.

    // Don't assign an empty stream to the srcObject
    // srcObject = new MediaStream()
    // it's laggy in Chrome

    video.srcObject = stream.videoTracks.length
      ? new MediaStream(stream.videoTracks)
      : null;

    const sub1 = merge(
      of(void 0),
      stream.addTrack$.pipe(
        filter((_) => _.kind === "video"),
        tap((_) => {
          video.srcObject = video.srcObject || new MediaStream();
          (video.srcObject as MediaStream).addTrack(_);
        })
      ),
      stream.removeTrack$.pipe(
        filter((_) => _.kind === "video"),
        tap((_) => {
          (video.srcObject as MediaStream)?.removeTrack?.(_);
        })
      )
    )
      .pipe(tap(() => subscriber.next()))
      .subscribe();

    return () => {
      sub1.unsubscribe();
    };
  });
}
